<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig?.widgetId}} widget-period-over-period" *ngIf="widgetData && selectedKpiEntries && displayData">
  <table class="widget-large widgetNoTopBorder cellspacing-0 cellpadding-0" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column" [attr.colspan]="allColspansCount" style="width: 100%">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr>
        <th scope="col" [attr.colspan]="allColspansCount" class="widget-title-pop widgetNoTopBorderShowCell widget-title-backgroundred" style="text-align:left;">
          {{'periodOverPeriod.labelTitle' | rdTranslate}}
        </th>
      </tr>

      <tr>
        <th scope="col" [attr.colspan]="labelColspan" class="widgetNoTopBorderShowCell darkGreyTableHeader">
          <widget-label [widget]="this" [fieldName]="'labelKeyPerformanceIndicators'" [align]="'left'" [bold]="true" [color]="'white'"></widget-label>
        </th>

        <th scope="col" [attr.colspan]="currrentValuationColspan" class="widgetNoTopBorderShowCell darkGreyTableHeader">
          <widget-label [widget]="this" [fieldName]="'labelCurrentValuation'" [color]="'white'" [align]="'left'" [bold]="true"></widget-label>
        </th>

        <ng-container *ngFor="let period of periods">
          <th scope="col" [attr.colspan]="periodColspan" *ngIf="period.visible" class="widgetNoTopBorderShowCell darkGreyTableHeader">{{period.label}}</th>
        </ng-container>

        <th scope="col" [attr.colspan]="comparisionColspan" class="widgetNoTopBorderShowCell darkGreyTableHeader">{{'periodOverPeriod.labelEvolutionCurrentValuationVs' | rdTranslate}} {{periodX?.label || 'Period X'}})</th>
        <th scope="col" [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodY" class="widgetNoTopBorderShowCell darkGreyTableHeader">{{'periodOverPeriod.labelEvolutionCurrentValuationVs' | rdTranslate}} {{periodY?.label || 'Period Y'}})</th>
      </tr>

      <!-- edit mode -->
      <ng-container *ngIf="editMode">
        <tr *ngFor="let entry of selectedKpiEntriesForLayoutEditMode; let i = index" [class.lightGreyRow]="i % 2 === 0" class="kpiRow">
          <td [attr.colspan]="buttonColspan" (click)="addRow(entry)" class="addRemoveItem gridster-item-content">+</td>
          <td [attr.colspan]="buttonColspan" (click)="removeRow(entry)" class="addRemoveItem gridster-item-content">-</td>
          <td [attr.colspan]="labelColspanWithButtons">
            <kendo-dropdownlist [data]="availableKpiEntries" style="width:98%" class="widget-input-text gridster-item-content"
                                textField="label"
                                valueField="label"
                                [valuePrimitive]="true"
                                [(ngModel)]="entry.label"
                                (valueChange)="onKpiChanged(entry, $event)"
                                [itemDisabled]="wrapIsTopicSelectionDisabled(this, entry)">
            </kendo-dropdownlist>
          </td>


          <td [attr.colspan]="currrentValuationColspan" *ngIf="!entry.unitLabelLeft">{{displayData.currentPeriod[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}} {{entry.unit}}</td>
          <td [attr.colspan]="currrentValuationColspan" *ngIf="entry.unitLabelLeft">{{entry.unit}} {{displayData.currentPeriod[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}}</td>

          <ng-container *ngFor="let period of periods">
            <td [attr.colspan]="periodColspan" *ngIf="period.visible && !entry.unitLabelLeft">{{displayData[period.reportId][entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}} {{entry.unit}}</td>
            <td [attr.colspan]="periodColspan" *ngIf="period.visible && entry.unitLabelLeft">{{entry.unit}} {{displayData[period.reportId][entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}}</td>
          </ng-container>

          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodX[entry.valueProperty] !== null">{{displayData.comparisonPeriodX[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlacesComparison}} {{entry.comparisonUnit}}</td>
          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodX[entry.valueProperty] === null">{{'common.notAvailable' | rdTranslate}}</td>

          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodY && displayData.comparisonPeriodX[entry.valueProperty] !== null">{{displayData.comparisonPeriodY[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlacesComparison}} {{entry.comparisonUnit}}</td>
          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodY && displayData.comparisonPeriodX[entry.valueProperty] === null">{{'common.notAvailable' | rdTranslate}}</td>

        </tr>
      </ng-container>

      <!-- view mode-->
      <ng-container *ngIf="!editMode">
        <tr *ngFor="let entry of selectedKpiEntriesForLayoutViewMode; let i = index" [class.lightGreyRow]="i % 2 === 0" class="kpiRow">
          <td [attr.colspan]="labelColspan">
            {{entry.label}}
          </td>


          <td [attr.colspan]="currrentValuationColspan" *ngIf="!entry.unitLabelLeft">{{displayData.currentPeriod[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}} {{entry.unit}}</td>
          <td [attr.colspan]="currrentValuationColspan" *ngIf="entry.unitLabelLeft">{{entry.unit}} {{displayData.currentPeriod[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}}</td>

          <ng-container *ngFor="let period of periods">
            <td [attr.colspan]="periodColspan" *ngIf="period.visible && !entry.unitLabelLeft">{{displayData[period.reportId][entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}} {{entry.unit}}</td>
            <td [attr.colspan]="periodColspan" *ngIf="period.visible && entry.unitLabelLeft">{{entry.unit}} {{displayData[period.reportId][entry.valueProperty] | rdLocalizedNumber:entry.decimalPlaces}}</td>
          </ng-container>

          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodX[entry.valueProperty] !== null">{{displayData.comparisonPeriodX[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlacesComparison}} {{entry.comparisonUnit}}</td>
          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodX[entry.valueProperty] === null">{{'common.notAvailable' | rdTranslate}}</td>

          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodY && displayData.comparisonPeriodX[entry.valueProperty] !== null">{{displayData.comparisonPeriodY[entry.valueProperty] | rdLocalizedNumber:entry.decimalPlacesComparison}} {{entry.comparisonUnit}}</td>
          <td [attr.colspan]="comparisionColspan" *ngIf="displayData.comparisonPeriodY && displayData.comparisonPeriodX[entry.valueProperty] === null">{{'common.notAvailable' | rdTranslate}}</td>


        </tr>
      </ng-container>

      <tr *ngIf="!hideFootnote">
        <td [attr.colspan]="allColspansCount">{{'periodOverPeriod.labelMonth1x12' | rdTranslate}}</td>
      </tr>

    </tbody>
  </table>
  <period-over-period-slide-out *ngIf="!rdStorage.getAppPrintMode()" [widget]="this" [periodValues]="widgetData.periodValues"></period-over-period-slide-out>
</div>
